module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAYCAYAAAHlv2/YAAAABGdBTUEAALGPC/xhBQAAAVZJREFUSA3VVtENgjAQBVdgExN1BkZxA//ELVzLGfTTBPjH4LsSSqFXClfAeEmhfXd971qvxShyWV3XheUDWHNgosFhxA6em/aaHYqE5Sam+3Bkyj3ysII1IO6Q2uhkX0DsC9DsFAg7asDVoSiXj8VpAhnrnAI209XTLgEPQUz+IPVG4KVeIDLL4NT4Ap4DwkMAVTMVhBe0agmi7hRJ2YzlvaUc9OuZm74XEQ1I/GXOqaxBAk6RpdOPNreUDtOV3aZRdj5hr2XCe/aBtSTXIntYSiMAfTZ6FsMAfNDuPcdSAyxbHWS8K7TzUryzeSBuHj8Mlc3avtmi3ATIcokUwMPvTU7QhY0kIrtXXEI+3JFICTz80+QTN/x0FWUYXw3sl119pXH1glw3tSfU0t5uAOASo0Letn56WWHwb4nlSFj2d2C4cumY2TH5Hx1pEtw8JJZQ43xLYV+R8rucXeUDTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./images/longArrowLeftWhite.png
// module id = 56
// module chunks = 0